import currency from './currency';
import street from './street';
import region from './region';
import date from './date';
import country from './country';

const FiltersPlugin = {
    install(Vue: any) {
        Vue.filter('currency', currency);
        Vue.filter('street', street);
        Vue.filter('region', region);
        Vue.filter('date', date);
        Vue.filter('country', country);
    },
};

export default FiltersPlugin;
